import { PaginationDTO, UserDTO } from '@/types';
import { ResponseDTO } from '@/types';
import { ResumeDTO } from '@/types/resume';
import request from '@/utils/request';

export function getUser(): Promise<UserDTO> {
  return request.get<UserDTO, ResponseDTO<UserDTO>, void>('/users/me').then((res) => res.data);
}

export function uploadResume(ossUrl: string): Promise<ResumeDTO> {
  return request
    .post<ResumeDTO, ResponseDTO<ResumeDTO>, { ossUrl: string }>('/resumes', { ossUrl })
    .then((res) => res.data);
}

export function getResumeList(): Promise<PaginationDTO<ResumeDTO>> {
  return request
    .get<PaginationDTO<ResumeDTO>, ResponseDTO<PaginationDTO<ResumeDTO>>, void>('/resumes', {})
    .then((res) => res.data);
}

export function getResume(resumeNumber: number): Promise<ResumeDTO> {
  return request
    .get<ResumeDTO, ResponseDTO<ResumeDTO>, void>(`/resumes/${resumeNumber}`)
    .then((res) => res.data);
}

export function logout(): Promise<void> {
  return request.post<void, ResponseDTO<void>, void>('/wechat/logout').then((res) => {
    window.config = null;
    return res.data;
  });
}

export function deleteResume(resumeNumber: number): Promise<ResponseDTO<void>> {
  return request.delete<void, ResponseDTO<void>, void>(`/resumes/${resumeNumber}`);
}

/**
 * 根据分享码获取邀请者信息
 * @param shareCode 分享码
 * @returns 邀请者用户信息，如果分享码无效则抛出错误
 */
export function getInviterByShareCode(shareCode: string): Promise<UserDTO> {
  return request
    .get<UserDTO, ResponseDTO<UserDTO>, void>(`/points/share-code/${shareCode}`)
    .then((res) => res.data);
}
